// app/javascript/controllers/find_party_validation_controller.js
import { Controller } from "@hotwired/stimulus"
import JustValidate from "just-validate"

export default class extends Controller {
    static targets = ["email", "error"]

    connect() {
        this.form = this.element
        this.emailEl = this.hasEmailTarget ? this.emailTarget : document.getElementById("find_party_email")
        this.errorEl = this.hasErrorTarget ? this.errorTarget : document.getElementById("find-party-error")

        // JustValidate setup
        this.validator = new JustValidate(this.form, { validateBeforeSubmitting: true })
        this.validator.addField('#find_party_email', [
            { rule: 'required', errorMessage: 'Email is required' },
            { rule: 'email',    errorMessage: 'Please enter a valid email address' }
        ])

        // Create the invisible reCAPTCHA widget
        if (window.grecaptcha) {
            this.widgetId = grecaptcha.render('find-party-recaptcha', {
                sitekey: document.querySelector('#find-party-recaptcha').dataset.sitekey,
                size: 'invisible',
                callback: token => this.submitAfterCaptcha(token)
            });
        } else {
            console.warn("reCAPTCHA not loaded yet.")
        }
    }

    disconnect() {
        this.validator?.destroy()
    }

    async submit(event) {
        event.preventDefault()

        const valid = await this.validator.revalidate().catch(() => false)
        if (!valid) {
            this.showError("Please enter a valid email address.")
            return
        }

        if (window.grecaptcha && this.widgetId !== undefined) {
            grecaptcha.reset(this.widgetId) // reset to ensure fresh token
            grecaptcha.execute(this.widgetId)
        } else {
            this.showLoader()
            this.form.submit()
        }
    }

    submitAfterCaptcha(token) {
        // Token is automatically added to hidden input by reCAPTCHA
        this.showLoader()
        this.form.submit()
    }

    showLoader() {
        const loader = this.application.getControllerForElementAndIdentifier(this.form, "form-loader")
        loader?.showLoader()
    }

    showError(msg) {
        if (!this.errorEl) return
        this.errorEl.textContent = msg
        this.errorEl.classList.remove("d-none")
    }

    hideError() {
        if (!this.errorEl) return
        this.errorEl.classList.add("d-none")
        this.errorEl.textContent = ""
    }
}